import React, { useEffect } from "react";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import Hero from "../../components/About/hero/Hero";
import { BRAND } from "../../data/brand";

function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero heading="Privacy Policy" />
      <div className="layout-container layout-container--narrow layout-section">
        <p className="text-gray-500">Last updated: March 2026</p>

        <h2 id="heading-md" className="mt-8">1. Information We Collect</h2>
        <p className="text-gray-700 mt-2">
          We collect personal information you provide when using our services, including
          name, email, phone number, address, academic records, financial documents, and
          passport details necessary for study-abroad applications.
        </p>

        <h2 id="heading-md" className="mt-8">2. How We Use Your Information</h2>
        <p className="text-gray-700 mt-2">
          Your information is used to provide consultancy services, process applications,
          communicate about your case, improve our services, and comply with legal
          obligations. We do not sell your personal data to third parties.
        </p>

        <h2 id="heading-md" className="mt-8">3. Data Sharing</h2>
        <p className="text-gray-700 mt-2">
          We share your information only with universities, embassies, visa authorities,
          accommodation providers, and payment processors as required to deliver our
          services. All third parties are bound by confidentiality agreements.
        </p>

        <h2 id="heading-md" className="mt-8">4. Data Security</h2>
        <p className="text-gray-700 mt-2">
          We implement industry-standard security measures including encrypted storage,
          secure payment processing, and access controls to protect your personal data.
        </p>

        <h2 id="heading-md" className="mt-8">5. Your Rights</h2>
        <p className="text-gray-700 mt-2">
          You have the right to access, correct, or delete your personal data. You may
          opt out of marketing communications at any time. Contact us at {BRAND.email}
          to exercise these rights.
        </p>

        <h2 id="heading-md" className="mt-8">6. Cookies</h2>
        <p className="text-gray-700 mt-2">
          Our website uses cookies to improve user experience and analyze site traffic.
          You can disable cookies in your browser settings.
        </p>

        <h2 id="heading-md" className="mt-8">7. Contact</h2>
        <p className="text-gray-700 mt-2">
          For privacy-related inquiries, contact {BRAND.name} at {BRAND.email} or
          {BRAND.address}.
        </p>
      </div>
      <Footer />
    </>
  );
}

export default Privacy;
